// eslint-disable-next-line
import { injectable } from "inversify";
import { IApiResponse, IHttpService } from "../http-service";
import { TYPE, rootContainer } from "../container/root";

export enum RETURNS_DATE_FIELD {
    CREATED = 'CREATED',
    SHIPPED = 'TRANSIT',
    DELIVERED = 'DELIVERED',
}

export enum CUSTOMER_COLUMN_USE {
    NAME = 1,
    ID = 0,
}

export interface IUISettings {
    returns_customer_display_mode: CUSTOMER_COLUMN_USE,
    returns_date_field: RETURNS_DATE_FIELD,
    /** Manage Returns redesign state. Backend derives both from ui_settings timestamps. */
    manage_returns_new_enabled: boolean,
    manage_returns_promo_declined: boolean,
}


@injectable()
class UISettingsService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    public async fetchUISettings(): Promise<IUISettings> {
        const res = await this.httpService.get<IApiResponse<IUISettings>>(`/rms-api/ui-settings`);
        return res.payload;
    }

    public async saveUISettings(uiSettings: Partial<IUISettings>): Promise<IUISettings> {
        const res = await this.httpService.post<IApiResponse<IUISettings>>(`/rms-api/ui-settings`, {
            ...uiSettings
        });
        return res.payload;
    }
}

export default UISettingsService;
